import { render, staticRenderFns } from "./socket-message.vue?vue&type=template&id=e15d717e&"
import script from "./socket-message.vue?vue&type=script&lang=js&"
export * from "./socket-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports